var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view story"},[(_vm.canPublish)?_c('PrimaryButton',{staticClass:"publish-button",attrs:{"text":_vm.$i18n('btn-next'),"onClick":_vm.onPublish}}):_vm._e(),_c('CurrentFrame'),_c('Frames'),_c('SearchToolbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }